import TopBar from './TopBar';

export default TopBar;



// WEBPACK FOOTER //
// ./src/components/shared/TopBar/index.js